import { css } from 'styled-system/css';

export const BettingStyleImageStyle = {
	// Betslip
	basicText1: css({
		pos: 'absolute',
		top: { _galaxy: '204px', _mars: '154px' },
		left: '68px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '3px',
		fontSize: '13px',
		color: { _galaxy: 'var(--lv1-100)' },
		lgx: {
			color: 'var(--p500)!',
			top: { _galaxy: '92px', _mars: '94px' },
			left: '329px',
			w: '116px',
			transform: 'scale(.5)',
			'& svg': {
				display: 'none',
			},
		},
	}),
	// Bet
	basicText2: css({
		pos: 'absolute',
		top: { _galaxy: '282px', _mars: '233px' },
		left: '195px',
		textAlign: 'center',
		w: '116px',
		color: { _galaxy: 'var(--lv2-100)', _mars: 'whiteOpacity.100' },
		fontWeight: '700',
		lgx: {
			top: { _galaxy: '235px', _mars: '234px' },
			left: '369px',
			w: '228px',
			transform: 'scale(.5)',
			transformOrigin: '0 0',
		},
	}),
	// over lg: My Bets / Statement
	basicText3: css({
		pos: 'absolute',
		textAlign: 'center',
		w: '116px',
		color: { _galaxy: 'var(--lv1-50)', _mars: 'black.2' },
		fontWeight: '700',
		display: 'none',
		lgx: {
			display: 'block',
			top: { _galaxy: '92px', _mars: '96px' },
			left: '393px',
			transform: 'scale(.5)',
		}
	}),
	// Betslip
	floatText1: css({
		pos: 'absolute',
		top: '7px',
		left: '30px',
		color: { _galaxy: 'var(--lv1-100)', _mars: 'whiteOpacity.100' },
		lgx: {
			top: { _galaxy: '50px', _mars: '57px' },
			left: '185px',
			transform: 'scale(.75)',
			transformOrigin: '0 0',
		},
	}),
	// Bet
	floatText2: css({
		pos: 'absolute',
		top: { _galaxy: '267px', _mars: '250px' },
		left: '7px',
		w: '306px',
		textAlign: 'center',
		color: { _galaxy: 'var(--lv2-100)', _mars: 'whiteOpacity.100' },
		fontSize: '16px',
		fontWeight: '700',
		lgx: {
			top: { _galaxy: '210px', _mars: '217px' },
			left: '181px',
			w: '251px',
			transform: 'scale(.75)',
			transformOrigin: '0 0',
		},
	}),
	// over lg: My Bets / Statement
	floatText3: css({
		pos: 'absolute',
		fontWeight: '700',
		display: 'none',
		lgx: {
			display: 'block',
			top: { _galaxy: '109px', _mars: '122px' },
			left: '381px',
			color: { _galaxy: 'var(--lv1-50)', _mars: 'black.2' },
			transform: 'scale(.5)',
			transformOrigin: '0 0',
			textAlign: 'left',
		}
	}),
	// over lg: Quick Bet / One-click Bet
	floatText4: css({
		pos: 'absolute',
		fontWeight: '700',
		display: 'none',
		lgx: {
			display: 'block',
			bottom: { _galaxy: '-5px', _mars: '-2px' },
			left: { _galaxy: '246px', _mars: '252px' },
			color: { _galaxy: 'var(--lv1-50)', _mars: 'black.2' },
			transform: 'scale(.5)',
			transformOrigin: '0 0',
			textAlign: 'left',
		}
	}),
}